import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import type { TaskStatus } from '@/api'

const badgeVariants = cva(
  'inline-flex items-center rounded-md px-2 py-1 text-[11px] font-mono font-medium ring-1 ring-inset',
  {
    variants: {
      status: {
        pending: 'bg-muted text-muted-foreground ring-border',
        in_progress: 'bg-primary/10 text-primary ring-primary/20',
        completed: 'bg-green-500/10 text-green-600 dark:text-green-400 ring-green-500/20',
        blocked: 'bg-red-500/10 text-red-600 dark:text-red-400 ring-red-500/20',
      },
    },
    defaultVariants: {
      status: 'pending',
    },
  }
)

const statusLabels: Record<TaskStatus, string> = {
  pending: 'Pending',
  in_progress: 'In Progress',
  completed: 'Completed',
  blocked: 'Blocked',
}

interface TaskStatusBadgeProps
  extends VariantProps<typeof badgeVariants> {
  status: TaskStatus
  className?: string
}

export function TaskStatusBadge({
  status,
  className,
}: TaskStatusBadgeProps) {
  return (
    <span className={cn(badgeVariants({ status }), className)}>
      {statusLabels[status]}
    </span>
  )
}
